module.exports = __webpack_public_path__ + "img/beer.d7229890.jpg";